import { render, staticRenderFns } from "./thirdDetails.vue?vue&type=template&id=d5481bc6&scoped=true&"
import script from "./thirdDetails.vue?vue&type=script&lang=js&"
export * from "./thirdDetails.vue?vue&type=script&lang=js&"
import style0 from "./thirdDetails.vue?vue&type=style&index=0&id=d5481bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5481bc6",
  null
  
)

export default component.exports